<template>
  <div class="m-card" :style="{ background: gradient }" style="width: 100%">
    <h4 class="tb_700" style="color:var(--text-color)">
      <slot name="title">Today total head count</slot>
    </h4>
    <div class="content" >
      <slot name="chart">
        <div class="chart">
          <DonutChart :chartOptions="chartOptions" :series="series" />
          <h4 class="text-center-chart tb_700">
            {{ ((series[0] / (series[0] + series[1])) * 100).toFixed(1) }}%
          </h4>
        </div>
      </slot>
      <div class="layout-text">
        <h3 class="tb_700">
          <slot name="text" :series="series">
            {{ series[0] }} / {{ series[0] + series[1] }}
          </slot>
        </h3>
        <span class="unit tb_700" :style="{ 'background-color': colors[0] }" style="color:#fff">
          <slot name="unit"> UNIT </slot>
        </span>
      </div>
    </div>
    <div style="display:flex;justify-content: flex-end;">
      <slot name="time"></slot>
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/ApexChart/DonutChart.vue";

export default {
  components: { DonutChart },
  props: {
    series: Array,
    colors: {
      type: Array,
      default: ["#00000000", "#00000000"],
    },
  },
  computed: {
    gradient() {
      let colors =
        "linear-gradient(180deg," +
        this.colors[0] +
        " 0px, var(--background-color-sidebar) 45px, var(--background-color-sidebar) 100px)";
      // let colors = "linear-gradient(45deg";
      // this.colors.forEach(function(e) {
      //   colors += "," + e + ' 50%';
      // });
      // colors += ")";
      // console.log(colors);
      return colors;
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: ["Active", "Inactive"],
        colors: this.colors,
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                //     name: {
                //     show: true,
                //     fontSize: '22px',
                //     formatter: function (val) {
                //   return val
                // },
                //     },

                //     value: {
                //     show: true,

                //     },

                // total: {
                //   show: true,
                //   showAlways: true,
                //   label: '',
                //   fontSize: "22px",
                //   fontFamily: "Helvetica, Arial, sans-serif",
                //   fontWeight: 600,
                //   color: "#373d3f",
                //   formatter: function (w) {
                //     return w.globals.seriesTotals.reduce((a, b) => {
                //       return a + b;
                //     }, 0);
                //   },
                // },
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: grid;
  grid: auto/150px auto;
  .layout-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
}
.card-gradient {
  background: linear-gradient(
    180deg,
    #f7b459 0px,
    var(--background-color-sidebar) 45px,
    var(--background-color-sidebar) 100%
  );
}
.chart {
  position: relative;
}
.text-center-chart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 700;
}

.tb_700 {
  font-weight: 700;
  color: var(--text-color-2);
  // color: white;

}

.unit {
  // background-color: #f7b459;
  padding: 0.3rem;
  border-radius: 0.3rem;
}
</style>